import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/SVGs/Sidebar/Logo";
import ToggleButton from "../../assets/SVGs/Sidebar/ToggleButton";
import Membership from "../../assets/SVGs/Sidebar/Membership";
import EnterMemberData from "../../assets/SVGs/Sidebar/EnterMemberData";
import Referrals from "../../assets/SVGs/Sidebar/Referrals";
import Meetups from "../../assets/SVGs/Sidebar/Meetups";
import Visitors from "../../assets/SVGs/Sidebar/Visitors";
import ClosedBusiness from "../../assets/SVGs/Sidebar/ClosedBusiness";
import WeeklyMeets from "../../assets/SVGs/Sidebar/WeeklyMeets";
import { useAuth } from "../../context/AuthContext";

const Sidebar = ({ className, isOpen, setIsOpen }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { user } = useAuth();

  const role = user?.role;
  const isAdmin = role === "ADMIN";

  const membershipPath = isAdmin ? "/membership" : "/member/membership";

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  const handleToggleClick = () => {
    if (window.innerWidth < 850) {
      setIsOpen(false);
    } else {
      toggleSidebar();
    }
  };

  return (
    <div
      className={`sidebar  ${className} ${isExpanded ? "" : "collapsed"} ${isOpen ? "mob-sidebar" : ""}`}
    >
      <div className="menu-item-header">
        <button className="toggle-btn" onClick={handleToggleClick}>
          <ToggleButton />
        </button>
        {isExpanded && (
          <div className="logo">
            <Logo />
          </div>
        )}
      </div>

      <ul className="menu flex flex-col">
        <li className="flex items-center menu-item-container">
          <NavLink
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
            to={membershipPath}
          >
            <span className="icon flex items-center">
              <Membership />
            </span>
            {isExpanded && <span className="label">Membership</span>}
          </NavLink>
        </li>

        {!isAdmin && (
          <li className="flex items-center menu-item-container">
            <NavLink
              className={({ isActive }) =>
                `menu-item ${isActive ? "active" : ""}`
              }
              to="/member/bulk"
            >
              <span className="icon flex items-center">
                <EnterMemberData />
              </span>
              {isExpanded && <span className="label">Enter member data</span>}
            </NavLink>
          </li>
        )}

        {isAdmin && (
          <>
            <li className="flex items-center menu-item-container">
              <NavLink
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
                to="/weekly-meets"
              >
                <span className="icon flex items-center">
                  <WeeklyMeets />
                </span>
                {isExpanded && <span className="label">Weekly Meets</span>}
              </NavLink>
            </li>
            <li className="flex items-center menu-item-container">
              <NavLink
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
                to="/meetups"
              >
                <span className="icon flex items-center">
                  <Meetups />
                </span>
                {isExpanded && <span className="label">Meet-Ups</span>}
              </NavLink>
            </li>
            <li className="flex items-center menu-item-container">
              <NavLink
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
                to="/referrals"
              >
                <span className="icon flex items-center">
                  <Referrals />
                </span>
                {isExpanded && <span className="label">Referrals</span>}
              </NavLink>
            </li>
            <li className="flex items-center menu-item-container">
              <NavLink
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
                to="/closed-business"
              >
                <span className="icon flex items-center">
                  <ClosedBusiness />
                </span>
                {isExpanded && <span className="label">Closed Business</span>}
              </NavLink>
            </li>
            <li className="flex items-center menu-item-container">
              <NavLink
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
                to="/visitors"
              >
                <span className="icon flex items-center">
                  <Visitors />
                </span>
                {isExpanded && <span className="label">Visitors</span>}
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
